import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Chivo', sans-serif;
    background-color: #f9f9f9;
    color: #333;
  }
`;

export default GlobalStyle;
